import React from "react";
import "./Card.css";
import { motion } from "framer-motion";

const variants = {
  hidden: {
    opacity: 0,
  },
  show: {
    opacity: 1,
  },
};

const Card = ({ image, description }) => {
  return (
    <motion.div variants={variants} className="card">
      {image}
      <p>{description}</p>
    </motion.div>
  );
};

export default Card;
